import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import adicionarFiltroAgendamentoViagem from '../../actions/agendamento-viagem/adicionarFiltroAgendamentoViagem'
import removerFiltroAgendamentoViagem from '../../actions/agendamento-viagem/removerFiltroAgendamentoViagem'
import listarFiltrosAgendamentoViagem from '../../actions/agendamento-viagem/listarFiltrosAgendamentoViagem'
import {
    FILTRO_CONTRATANTE,
    FILTRO_PERIODO_AGENDAMENTO,
    FILTRO_QUILOMETRAGEM, FILTRO_VALOR_TOTAL,
    FILTRO_VEICULO_DESCRI,
} from '../../util/filtros'
import FiltroBuscaAgendamentoViagem from './FiltroBuscaAgendamentoViagem';

export class FiltroAgendamentoViagem extends Component {
    componentDidMount() {
        if (this.props.empresaSelecionada)
            this.props.listarFiltrosAgendamentoViagem(this.props.empresaSelecionada.id)
    }

    adicionarFiltro(filtro) {
        this.props.adicionarFiltroAgendamentoViagem(filtro)
    }

    removerFiltro(filtro) {
        this.props.removerFiltroAgendamentoViagem(filtro)
    }

    render() {
        return (
            <React.Fragment>
                <div className="conteudo">
                    <FiltroBuscaAgendamentoViagem
                        filtro={FILTRO_CONTRATANTE}
                        isNome={true}
                    />
                    <FiltroBuscaAgendamentoViagem
                        filtro={FILTRO_QUILOMETRAGEM}
                        isNome={true}
                    />
                    <FiltroBuscaAgendamentoViagem
                        filtro={FILTRO_VEICULO_DESCRI}
                        isNome={true}
                    />
                    <FiltroBuscaAgendamentoViagem
                        filtro={FILTRO_VALOR_TOTAL}
                        isNome={true}
                    />
                    <FiltroBuscaAgendamentoViagem
                        filtro={FILTRO_PERIODO_AGENDAMENTO}
                        opcoes={[new Date().getFullYear()]}
                        isFiltroData={true}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export const mapStateToProps = state => ({
    veiculos: state.filtrosAgendamentoViagem.veiculos,
    contratantes: state.filtrosAgendamentoViagem.contratantes,
    quilometros: state.filtrosAgendamentoViagem.quilometros,
    valores: state.filtrosAgendamentoViagem.valores,
    filtrosAdicionados: state.filtrosAdicionadosAgendamentoViagem,
    empresaSelecionada: state.empresaSelecionada,

})

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        adicionarFiltroAgendamentoViagem,
        removerFiltroAgendamentoViagem,
        listarFiltrosAgendamentoViagem: listarFiltrosAgendamentoViagem,
    }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroAgendamentoViagem)
